
import type { PropOptions } from 'vue';
import Vue from 'vue';
import type { IPostTopic } from '@/types/community';
import WarRoomTopic from '@/components/partials/war-room/WarRoomTopic/WarRoomTopic.vue';

export default Vue.extend({
  name: 'WarRoomPostTopics',
  components: {
    WarRoomTopic,
  },
  props: {
    topics: {
      type: Array,
      default: () => [],
      required: true,
    } as PropOptions<Array<IPostTopic>>,
  },
});
